import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { API_URL } from "@/env";
import { setCookie } from "@/lib/cookies";
// import { toast } from "sonner";
import { showCustomToast } from "@/components/CustomToast";

const CompleteSignup = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const completeSignup = async () => {
      const token = searchParams.get("token");

      if (!token) {
        showCustomToast("Invalid signup link", "exclamation");
        navigate("/auth");
        return;
      }

      try {
        const response = await fetch(
          `${API_URL}/auth/complete-signup-from-link`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ token }),
          }
        );

        const data = await response.json();

        // if (!response.ok) {
        //   throw new Error(data.message || "Failed to complete signup");
        // }

        // Save the auth token
        if (data.access_token) {
          setCookie("token", data.access_token, {
            expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
          });
        }

        showCustomToast("Redirecting to workspace", "check");

        // Redirect to workspace if available, otherwise go to dashboard
        if (data.redirectWorkspaceId) {
          navigate(`/dashboard/${data.redirectWorkspaceId}`);
        } else {
          navigate("/dashboard");
        }
      } catch (error: any) {
        console.error("Complete signup error:", error);
        // showCustomToast("Failed to complete signup");
        navigate("/auth");
      }
    };

    completeSignup();
  }, [searchParams]);

  // Show loading state while processing
  // return (
  //   <div className="min-h-screen flex items-center justify-center bg-black">
  //     <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
  //   </div>
  // );]
  return <div />;
};

export default CompleteSignup;
